import { logError } from '@hotjar/insights-common/lib/logger';
import type { FilterMetadata } from '../../domains/global-filters/model/FilterChain';
import { FilterCategoryEnum, FilterKindEnum } from '../../domains/global-filters/model/FilterChain';

const getUnknownMetaData = (kind: FilterKindEnum): FilterMetadata => {
  logError(new Error(`Unknown Filter kind (We shouldn't reach this part): ${kind}`));
  return {
    filterName: 'Unknown',
    iconName: 'warning',
    categoryName: FilterCategoryEnum.Session,
  };
};

const filterMetadataRecord: Record<
  Exclude<FilterKindEnum, FilterKindEnum.Funnel>,
  FilterMetadata
> = {
  [FilterKindEnum.NewReturningUserKind]: {
    filterName: 'New / Returning',
    iconName: 'user_single',
    categoryName: FilterCategoryEnum.Session,
  },
  [FilterKindEnum.RageClickKind]: {
    filterName: 'Rage click',
    iconName: 'rage_click',
    categoryName: FilterCategoryEnum.Behavior,
  },
  [FilterKindEnum.UTurnKind]: {
    filterName: 'U-turn',
    iconName: 'uturn',
    categoryName: FilterCategoryEnum.Behavior,
  },
  [FilterKindEnum.TeamComment]: {
    filterName: 'Team comments',
    iconName: 'comment',
    categoryName: FilterCategoryEnum.Session,
  },
  [FilterKindEnum.DeviceType]: {
    filterName: 'Device',
    iconName: 'device_multiple',
    categoryName: FilterCategoryEnum.Technology,
  },
  [FilterKindEnum.OS]: {
    filterName: 'Operating system',
    iconName: 'unknown',
    categoryName: FilterCategoryEnum.Technology,
  },
  [FilterKindEnum.Browser]: {
    filterName: 'Browser',
    iconName: 'browser',
    categoryName: FilterCategoryEnum.Technology,
  },
  [FilterKindEnum.Country]: {
    filterName: 'Country',
    iconName: 'location',
    categoryName: FilterCategoryEnum.Session,
  },
  [FilterKindEnum.Event]: {
    filterName: 'Event',
    iconName: 'lightning',
    categoryName: FilterCategoryEnum.Behavior,
  },
  [FilterKindEnum.GoogleOptimize]: {
    filterName: 'Google Optimize',
    iconName: 'google_optimize',
    categoryName: FilterCategoryEnum.Experiment,
  },
  [FilterKindEnum.Optimizely]: {
    filterName: 'Optimizely',
    iconName: 'optimizely',
    categoryName: FilterCategoryEnum.Experiment,
  },
  [FilterKindEnum.Unbounce]: {
    filterName: 'Unbounce',
    iconName: 'unbounce_alt',
    categoryName: FilterCategoryEnum.Experiment,
  },
  [FilterKindEnum.UserAttribute]: {
    filterName: 'User attribute',
    iconName: 'user_attribute',
    categoryName: FilterCategoryEnum.UserAttributes,
  },
  [FilterKindEnum.VisitedURL]: {
    filterName: 'Viewed page',
    iconName: 'page_empty',
    categoryName: FilterCategoryEnum.Path,
  },
  [FilterKindEnum.LandingURL]: {
    filterName: 'Landing page',
    iconName: 'page_empty',
    categoryName: FilterCategoryEnum.Path,
  },
  [FilterKindEnum.ExitURL]: {
    filterName: 'Exit page',
    iconName: 'page_empty',
    categoryName: FilterCategoryEnum.Path,
  },
  [FilterKindEnum.ReferrerURL]: {
    filterName: 'Referrer URL',
    iconName: 'hyperlink',
    categoryName: FilterCategoryEnum.Path,
  },
  [FilterKindEnum.PageURL]: {
    filterName: 'Page URL',
    iconName: 'hyperlink',
    categoryName: FilterCategoryEnum.Path,
  },
  [FilterKindEnum.IncomingFeedback]: {
    filterName: 'Feedback',
    iconName: 'like',
    categoryName: FilterCategoryEnum.Feedback,
  },
  [FilterKindEnum.SurveyCompletionKind]: {
    filterName: 'Survey completion',
    iconName: 'boolean',
    categoryName: FilterCategoryEnum.Feedback,
  },
  [FilterKindEnum.NPS]: {
    filterName: 'Net Promoter Score ®',
    iconName: 'chart_bar',
    categoryName: FilterCategoryEnum.Feedback,
  },
  [FilterKindEnum.UserID]: {
    filterName: 'Hotjar user ID',
    iconName: 'user_single',
    categoryName: FilterCategoryEnum.Technology,
  },
  [FilterKindEnum.Keyword]: {
    filterName: 'Keyword',
    iconName: 'text',
    categoryName: FilterCategoryEnum.Feedback,
  },
  [FilterKindEnum.PageCount]: {
    filterName: 'Page count',
    iconName: 'layers',
    categoryName: FilterCategoryEnum.Session,
  },
  [FilterKindEnum.SessionDuration]: {
    filterName: 'Duration',
    iconName: 'time',
    categoryName: FilterCategoryEnum.Session,
  },
  [FilterKindEnum.Clicked]: {
    filterName: 'Clicked element',
    iconName: 'cursor_click',
    categoryName: FilterCategoryEnum.Behavior,
  },
  [FilterKindEnum.Error]: {
    filterName: 'Error',
    iconName: 'code_dev',
    categoryName: FilterCategoryEnum.Behavior,
  },
};

export const getFilterMetadata = (kind: FilterKindEnum): FilterMetadata => {
  return kind !== FilterKindEnum.Funnel && filterMetadataRecord[kind] !== undefined
    ? filterMetadataRecord[kind]
    : getUnknownMetaData(kind);
};
